// @ts-strict-ignore
import styled from "@emotion/styled";
import { Text } from "@hubble/web";
import type { text } from "@hubble/tokens/web";
import type { TextComponentDisplaySize } from "./constants";
import { displayProps, headingProps } from "./constants";
import { mediaQuery } from "utils";
type TextType = Exclude<keyof (typeof text)["typesets"], "numeric" | "body">;

export const ReflectableText = styled(Text)<{ reflectableContent?: string }>`
  ${({ reflectableContent }) =>
    reflectableContent &&
    `
    display: block;
    padding: 0;
    margin: 0;
    text-transform: none;
    position: relative;
    &::after {
      position: absolute;
      top: 80%;
      left: 0;
      width: 100%;
      filter: blur(1px);
      content: '${reflectableContent}';
      transform: scale(1, -1);
      backface-visibility: visible; 
      z-index: 1;
      -webkit-mask-image:-webkit-gradient(linear, left top, left bottom, color-stop(100%, rgba(0,0,0,0.4)), color-stop(40%, rgb(0,0,0,0)))
    }
  `};
`;

export const LargeTextResponsive = styled(ReflectableText)<{
  // TextComponentBaseSize is a subset of TextComponentDisplaySize
  textSize: TextComponentDisplaySize;
  textType: TextType;
  fontSize?: string | number;
  lineHeight?: string | number;
}>`
  ${({ textSize, textType, fontSize, lineHeight }) => {
    const sizes = textType === "display" ? displayProps : headingProps;
    return `
    font-size: ${fontSize || sizes.mobile[textSize].fontSize};
    line-height: ${lineHeight || sizes.mobile[textSize].lineHeight};

    @media ${mediaQuery.desktopLgUp} {
        font-size: ${fontSize || sizes.desktop[textSize].fontSize};
        line-height: ${lineHeight || sizes.desktop[textSize].lineHeight};
    }`;
  }}
`;
